export class CookieJar {
  constructor () {
    throw new TypeError('Cookie jars are not available in browsers')
  }
}
